import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Storage } from '@ionic/storage';
import { NavController, AlertController, ToastController, IonContent } from '@ionic/angular';
import { NavigationExtras, Router } from '@angular/router';
import { UtilService } from '../../service/util.service';
import { UserProfile } from '../../models/user-profile.model';
import { UserData } from '../../providers/user-data';
import { PromotionsService } from './promotions.service';
import { RoleAccess } from '../../models/role-access.model';
import { AES } from 'crypto-js';
import { environment } from '../../../environments/environment';

@Component({
  selector: "app-promotions",
  templateUrl: "./promotions.page.html",
  styleUrls: ["./promotions.page.scss"],
})
export class PromotionsPage implements OnInit {
  page = {
    limit: 10,
    count: 0,
    offset: 0,
    orderBy: "",
    orderDir: "desc",
  };

  rows: any;
  token: any;
  userProfile: UserProfile = new UserProfile();
  promotionList: any;
  filteredData: any;
  counterId: any = "";
  picList: any[] = [];
  keywordSearch: any;

  db: any;

  counterTableName = "mst_counters";
  counterColumnList =
    "(id, branch_id, counter_name, trans_date, first_address, last_address, phone, footer_text, latitude, longitude, active, created_by, updated_by, created_at, updated_at)";
  warehouseTableName = "mst_warehouses";
  warehouseColumnList =
    "(id, counter_id, warehouse_name, warehouse_type_id, unit_size, length_size, width_size, height_size, active, created_by, updated_by, created_at, updated_at)";

  roleAccess = new RoleAccess();
  allowUploadPromo: boolean = false;
  @ViewChild("tableWrapper", { static: false }) tableWrapper!: ElementRef;
  @ViewChild("content", { static: false }) content!: IonContent;

  constructor(
    private storage: Storage,
    private navCtrl: NavController,
    private alertController: AlertController,
    private utilService: UtilService,
    private toastCtrl: ToastController,
    private userData: UserData,
    private promotionService: PromotionsService,
    private router: Router
  ) {}

  ngOnInit() {}

  ionViewDidEnter() {
    this.allowUploadPromo = false;
    Promise.all([
      this.storage.get("user_token"),
      this.storage.get("user_profile"),
      this.storage.get("user_menu_access"),
    ]).then(([token, profile, access]) => {
      if (token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        console.log(this.userProfile);
        this.roleAccess = this.userData.checkAccess(
          this.router.url,
          access,
          this.userProfile
        );
        if (!this.roleAccess || this.roleAccess.view != "1") {
          this.toastCtrl
            .create({
              duration: 2000,
              message: "You Are Not Allowed to Access this Page",
            })
            .then((t) => t.present());
          this.navCtrl.navigateForward(["/"]);
        } else {
          this.pageCallback({ offset: this.page.offset });
        }
      } else {
        this.toastCtrl
          .create({
            duration: 2000,
            message: "Silahkan login terlebih dahulu.",
          })
          .then((t) => t.present());
        this.navCtrl.navigateForward(["/login"]);
      }
    });
  }

  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.reloadTable("x");
  }

  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.reloadTable("x");
  }

  reloadTable(offsett: any) {
    console.log(offsett);
    this.utilService.loadingPresent("Harap tunggu...").then(() => {
      if (offsett == "0") {
        this.page.offset = 0;
      }
      let offset = this.page.offset + 1;
      let options = {
        token: this.token,
        page: offset.toString(),
        counter_id:
          this.userProfile.counter_id !== 0
            ? this.userProfile.counter_id
            : this.userProfile.counter_id_list,
        keywords: this.keywordSearch ? this.keywordSearch : "null",
      };
      console.log(options);
      console.log(this.page);
      this.promotionService.getPromotion(options).subscribe(
        (response) => {
          this.utilService.loadingDismiss();
          this.page.count = response.results.promotion.total;
          this.rows = response.results.promotion.data;
          this.filteredData = response.results.promotion.data;
          this.promotionList = response.results.promotion.data;
          this.picList = response.results.pic;
          let employeeId = this.userProfile.employee_id;
          let roleId = this.userProfile.role_id;
          let checkRole = this.picList.find(
            (x) => x.based_on == "role" && x.role_id == roleId
          );
          if (checkRole) {
            this.allowUploadPromo = true;
          }
          let checkEmployee = this.picList.find(
            (x) => x.based_on == "employee" && x.employee_id == employeeId
          );
          if (checkEmployee) {
            this.allowUploadPromo = true;
          }
          if (offsett == "0") {
            // kalau habis duplikat langsung scroll keatas
            this.content.scrollToTop(400); // 400ms smooth scroll
          }
        },
        (err) => {
          this.utilService.loadingDismiss();
          console.log(err);
          if (err.error.error === "token_expired") {
            this.userData.logout().then(() => {
              this.toastCtrl
                .create({
                  duration: 2000,
                  message: "Token telah expired. Silahkan login kembali",
                })
                .then((t) => t.present());
              this.navCtrl.navigateForward(["/login"]);
            });
          } else {
            this.toastCtrl
              .create({ duration: 2000, message: "Gagal terhubung ke server" })
              .then((t) => t.present());
          }
        }
      );
    });
  }

  goToPromotionCreate() {
    this.navCtrl.navigateForward(["/promotions/promotion-create"]);
  }
  goToPromotionFormPage(id: any,actionType:any) {
    let myKey = environment.myKey;
    let encryptID = AES.encrypt(JSON.stringify(id),myKey).toString();
    let encryptAction = AES.encrypt(JSON.stringify(actionType),myKey).toString();
    let navigationExtras: NavigationExtras = {
      queryParams: {
        i: encryptID,
        a:encryptAction
      }
    };
    this.navCtrl.navigateForward(['/promotions/promotion-form'], navigationExtras);
  }

  goToPromotionUpload() {
    this.navCtrl.navigateForward(["/promotions/promotion-upload"]);
  }

  goToUpdatePage(id: any) {
    let myKey = environment.myKey;
    let encryptID = AES.encrypt(JSON.stringify(id), myKey).toString();
    let navigationExtras: NavigationExtras = {
      queryParams: {
        i: encryptID,
      },
    };
    this.navCtrl.navigateForward(
      ["/promotions/promotion-edit"],
      navigationExtras
    );
  }

  goToPromotionDetail(id: any) {
    let myKey = environment.myKey;
    let encryptID = AES.encrypt(JSON.stringify(id), myKey).toString();
    let navigationExtras: NavigationExtras = {
      queryParams: {
        i: encryptID,
      },
    };
    this.navCtrl.navigateForward(["/promotion-detail"], navigationExtras);
  }

  goToDetail(id: any) {
    let myKey = environment.myKey;
    let encryptID = AES.encrypt(JSON.stringify(id), myKey).toString();
    let navigationExtras: NavigationExtras = {
      queryParams: {
        i: encryptID,
      },
    };
    this.navCtrl.navigateForward(
      ["/promotions/promotion-detail"],
      navigationExtras
    );
  }
  deleteData(id: any) {
    this.utilService.loadingPresent("Harap tunggu...").then(() => {
      this.promotionService.deletePromotion(id).subscribe(
        (response) => {
          this.utilService.loadingDismiss();
          if (response.status.code === 200) {
            this.showDeleteSuccess();
          } else {
            this.toastCtrl
              .create({ duration: 2000, message: "Terdapat Error" })
              .then((t) => t.present());
          }
        },
        () => {
          this.utilService.loadingDismiss();
          this.toastCtrl
            .create({ duration: 2000, message: "Gagal terhubung ke server" })
            .then((t) => t.present());
        }
      );
    });
  }

  async showDeleteSuccess() {
    const alert = await this.alertController.create({
      header: "Notification",
      cssClass: "custom-alert-class",
      message: "Berhasil hapus data!",
      buttons: [
        {
          text: "OK",
          handler: () => {
            this.pageCallback({ offset: this.page.offset });
          },
        },
      ],
    });

    await alert.present();
  }

  async showConfirmDelete(id: any) {
    const alert = await this.alertController.create({
      header: "Delete Confirmation",
      cssClass: "custom-alert-class",
      message: "Apakah anda yakin untuk hapus data ini?",
      buttons: [
        {
          text: "Cancel",
          handler: () => {},
        },
        {
          text: "OK",
          handler: () => {
            this.deleteData(id);
          },
        },
      ],
    });

    await alert.present();
  }

  searchWithKeywords() {
    this.pageCallback({ offset: this.page.offset });
  }

  filterDatatable(event) {
    let val = event.target.value.toLowerCase();
    let columnLength = 18;
    let keys = Object.keys(this.promotionList[0]);
    this.rows = this.filteredData.filter(function (item) {
      for (let i = 0; i < columnLength; i++) {
        if (item[keys[i]] !== null) {
          if (
            item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 ||
            !val
          ) {
            return true;
          }
        }
      }
    });

    this.page.offset = 0;
  }

  async showConfirmSend(id: any) {
    const alert = await this.alertController.create({
      header: "Send Approval Confirmation",
      cssClass: "custom-alert-class",
      message: "Apakah anda yakin untuk send approval data ini?",
      buttons: [
        {
          text: "Tidak",
          handler: () => {},
        },
        {
          text: "Ya",
          handler: () => {
            this.sendApproval(id);
          },
        },
      ],
    });

    await alert.present();
  }

  sendApproval(id: any) {
    let options = {
      token: this.token,
      id: id,
      updated_by: this.userProfile.username,
      approval_status: "2",
    };
    this.utilService.loadingPresent("Harap tunggu...").then(() => {
      this.promotionService.sendApproval(options).subscribe(
        (response) => {
          console.log(response);
          this.utilService.loadingDismiss();
          if (response.status.code === 200) {
            console.log("send approval");
            console.log(response);
            this.reloadTable("x");
          }else if (response.status.code === 222) {
            this.toastCtrl
              .create({ duration: 2000, message: response.message })
              .then((t) => t.present());
          } else {
            this.toastCtrl
              .create({ duration: 2000, message: "Terdapat Error" })
              .then((t) => t.present());
          }
        },
        () => {
          this.utilService.loadingDismiss();
          this.toastCtrl
            .create({ duration: 2000, message: "Gagal terhubung ke server" })
            .then((t) => t.present());
        }
      );
    });
  }

  async showConfirmDuplicate(id: any) {
    const alert = await this.alertController.create({
      header: "Send Approval Confirmation",
      cssClass: "custom-alert-class",
      message: "Apakah anda yakin untuk menduplikat promo ini?",
      buttons: [
        {
          text: "Tidak",
          handler: () => {},
        },
        {
          text: "Ya",
          handler: () => {
            this.duplicatePromo(id);
          },
        },
      ],
    });

    await alert.present();
  }

  duplicatePromo(id: any) {
    let options = {
      token: this.token,
      id: id,
      updated_by: this.userProfile.username,
    };
    this.utilService.loadingPresent("Harap tunggu...").then(() => {
      this.promotionService.duplicatePromo(options).subscribe(
        (response) => {
          this.utilService.loadingDismiss();
          if (response.status.code === 200) {
            console.log(response);
            this.reloadTable("0");
          } else {
            this.toastCtrl
              .create({ duration: 2000, message: "Terdapat Error" })
              .then((t) => t.present());
          }
        },
        () => {
          this.utilService.loadingDismiss();
          this.toastCtrl
            .create({ duration: 2000, message: "Gagal terhubung ke server" })
            .then((t) => t.present());
        }
      );
    });
  }
}
